import { useEffect, useState } from 'react';

const PATTERN = /^(?<content>(.+))\s+(?<lastWord>[^\s]+)$/;
const UNBREAKABLE_SPACE = '\u00A0';
export const avoidOrphan = (text: string) => {
  return text.replace(PATTERN, `$<content>${UNBREAKABLE_SPACE}$<lastWord>`);
};

type Boldness = 'italic' | 'light' | 'normal' | 'bold' | 'bolder' | number;
export type Font = `${Boldness} ${number}px ${string}`;
export const getTextSize = (
  text: string,
  font: Font,
  letterSpacing: string = '0'
) => {
  if (import.meta.env.NODE_ENV === 'test') {
    return { width: 0, height: 0 };
  }

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d')!;
  context.font = font;

  context.letterSpacing = letterSpacing;

  const metrics = context.measureText(text);

  return {
    width: metrics.width,
    height: metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent,
  };
};

const fontFaceExtract = /(?<boldness>\w+) (?<size>[\w.]+) (?<family>.*)/;

export const useTextSize = (
  text: string,
  font: Font,
  letterSpacing: string = '0'
) => {
  const { family }: { family?: string } =
    fontFaceExtract.exec(font)?.groups || {};
  const [fontStatus, setFontStatus] = useState('initial');
  const firstFont = family
    .replace(/['"]/g, '')
    .split(/, ?/)[0]
    .toLocaleLowerCase();

  useEffect(() => {
    document.fonts.ready.then(fontFaceSet => {
      const fontFaceLoaded =
        [...fontFaceSet].filter(({ family: f, status }) => {
          return f.toLowerCase() === firstFont && status === 'loaded';
        })?.length > 0;
      if (fontFaceLoaded) {
        setFontStatus('loaded');
      }
    });
  }, [firstFont]);

  if (fontStatus === 'initial') {
    return { width: 0, height: 0 };
  }
  return getTextSize(text, font, letterSpacing);
};
